import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-71ecba49")

_pushScopeId("data-v-71ecba49")
const _hoisted_1 = { class: "flex-center margin-bottom-10" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("取消")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_cascader = _resolveComponent("el-cascader")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_tag_input = _resolveComponent("tag-input")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_drawer = _resolveComponent("el-drawer")

  return (_openBlock(), _createBlock(_component_el_drawer, {
    title: "设置冥想音频匹配规则",
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.dialogVisible = $event)),
    direction: "rtl",
    width: "40%"
  }, {
    default: _withId(() => [
      _createVNode(_component_el_form, {
        ref: "formDom",
        inline: true,
        "label-position": "right",
        "label-width": "80px",
        model: _ctx.formData
      }, {
        default: _withId(() => [
          _createVNode(_component_el_form_item, {
            prop: "categoryIds",
            label: "匹配分类"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_cascader, {
                filterable: "",
                modelValue: _ctx.formData.categoryIds,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.categoryIds = $event)),
                options: _ctx.demoCategories,
                props: {value: 'id', label: 'name', checkStrictly: true}
              }, null, 8, ["modelValue", "options"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            prop: "tags",
            label: "匹配标签"
          }, {
            default: _withId(() => [
              _createVNode(_component_tag_input, {
                alwaysShowInput: true,
                modelValue: _ctx.formData.tags,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.tags = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "选项配置",
            style: {"display":"block"}
          }, {
            default: _withId(() => [
              _createVNode(_component_el_table, {
                data: _ctx.formData.options,
                height: "100%",
                class: "w-full"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_table_column, {
                    prop: "name",
                    label: "选项",
                    width: "80px"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "defaultTags",
                    label: "默认标签",
                    width: "200px"
                  }, {
                    default: _withId(({row}) => [
                      _createVNode(_component_tag_input, {
                        skipLoadData: true,
                        allowAddNewTag: false,
                        alwaysShowInput: true,
                        singleMode: true,
                        modelValue: row.defaultTags,
                        "onUpdate:modelValue": ($event: any) => (row.defaultTags = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "nonDefaultTags",
                    width: "200px",
                    label: "非默认标签"
                  }, {
                    default: _withId(({row}) => [
                      _createVNode(_component_tag_input, {
                        skipLoadData: true,
                        allowAddNewTag: false,
                        alwaysShowInput: true,
                        singleMode: true,
                        modelValue: row.nonDefaultTags,
                        "onUpdate:modelValue": ($event: any) => (row.nonDefaultTags = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data"])
            ]),
            _: 1
          }),
          _createVNode("div", _hoisted_1, [
            _createVNode(_component_el_button, {
              class: "margin-right-10",
              type: "primary",
              onClick: _ctx.submit
            }, {
              default: _withId(() => [
                _hoisted_2
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, { onClick: _ctx.cancel }, {
              default: _withId(() => [
                _hoisted_3
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
})